import http from '../common/http'

export const GetArea = () => (
    http.get('/area/getarea')
)

export const GetAreaList = parentCode => (
		http.get('/area/GetAreaList', { parentCode: parentCode })
)



// WEBPACK FOOTER //
// ./src/api/areaApi.js